// extracted by mini-css-extract-plugin
export default {"modal-prompt-search-bar":"ModalPromptSearch_modal-prompt-search-bar__x1EBX","modal-prompt-search-results":"ModalPromptSearch_modal-prompt-search-results__6HvlK"};